import { useCallback, useState } from 'react';
import { useModal } from 'mui-modal-provider';

import { OrderCancelModal } from './order-cancel-modal';
import { INotificationNc } from '../../../../../../graphql/app-level-modals/models/get-modals-data.model';
import { NotificationType } from '../../../../../../models/notification.models';

export const useOrderCancelledModal = () => {
  const [shouldModalUpdate, setModalUpdateState] = useState(true);
  const { showModal } = useModal();

  const handleOrderCancelModal = useCallback(
    (notifications: INotificationNc[]) => {
      if (!shouldModalUpdate) return;

      const cancelNotification = notifications?.find(
        (notification) => notification.type === NotificationType.ORDER_CANCEL_BY_STORE,
      );

      const getOrderNumber = cancelNotification && JSON.parse(cancelNotification.data).orderNumber;
      if (cancelNotification && !cancelNotification?.acknowledged) {
        showModal(OrderCancelModal, {
          notificationId: cancelNotification.id,
          orderNumber: getOrderNumber,
        });
        setModalUpdateState(false);
      }
    },
    [shouldModalUpdate, showModal],
  );

  return {
    handleOrderCancelModal,
  };
};
